const spacers =  {
  pageMargin: '0 32px',
};

export default spacers;
